<template>
    <div class="my_news_container">
        <div class="notice_type_box">
            <ul class="news_tab_ul">
                <li
                  :class="['news_tab_li', {'active': noticeType == item.noticeType}]"
                  @click="changeNoticeType(item.noticeType)"
                  v-for="(item, index) in noticeTab"
                  :key="index"
                >
                    <i :class="['read_num', {'single_num': item.unReadNum < 10}]" v-show="item.unReadNum != 0">{{item.unReadNum}}</i>{{item.name}}
                </li>
            </ul>
            <span class="read_all" @click="readAllNotice">一键全读</span>
        </div>
        <!-- 有数据时 -->
        <ul class="notice_list_ul" v-if="hasNotice == true">
            <li
              class="notice_list_li"
              v-for="(item, index) in noticeList"
              :key="index"
              @click="toDetail(item)"
            >
                <span :class="['notice_icon', {'isRead': item.isRead == true}]"></span>
                <div class="notice_content">
                    <p class="title" v-html="item.title"></p>
                    <p class="content" v-html="item.content"></p>
                    <p class="time">{{formatTime(item.pushDate)}}</p>
                </div>
            </li>
        </ul>
        <div class="pagination_container" v-if="hasNotice == true">
            <m-pagination :currentpage="currentPage" :total="totalCount" @current-change="currentChange"></m-pagination>
        </div>
        <!-- 无数据时 -->
        <div class="no_notice" v-if="hasNotice == false">
            <i class="no_notice_icon"></i>
            <span class="no_notice_text">您当前还没有任何消息，快去看看我们的赛事吧</span>
        </div>
    </div>
</template>
<script>
import { personalCenter } from '@/config/request'
import { changeTime } from '@/config/utils'
export default {
    name: 'myNews',
    props: {
        userInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            accountId: '', // 用户id
            access_token: '',
            noticeType: 1, // 消息类型
            noticeTab: [
                {name: '赛事', noticeType: 1},
                {name: '新闻', noticeType: 3},
                {name: '通知', noticeType: 8},
            ],
            noticeList: [], // 消息数据
            currentPage: 1, // 当前页
            totalCount: 0, // 总条数
            eventNum: '', // 赛事未读数量
            newsNum: '', // 新闻未读数量
            systemNum: '', // 通知未读数量
            hasNotice: true, // 是否有消息
        }
    },
    methods: {
        // 获取数据
        getData() {
            personalCenter.getNoticeData({
                // accountId: this.accountId,
                type: this.noticeType,
                pageNo: this.currentPage,
                pageSize: 10,
                access_token: sessionStorage.getItem('access_token')
            }).then(res => {
                this.noticeList = res.list
                this.totalCount = res.count
                if(this.noticeList.length > 0) {
                    this.hasNotice = true
                } else {
                    this.hasNotice = false
                }
            })
        },
        // 获取消息未读数量
        getNoticeQuantity() {
            personalCenter.getNoticeQuantity({
                accountId: this.accountId,
            }).then(res => {
                this.noticeTab.forEach(item => {
                    switch (item.noticeType) {
                        case 1:
                            this.$set(item, 'unReadNum', res.objectData.match_message)
                            break;
                        case 3:
                            this.$set(item, 'unReadNum', res.objectData.news_message)
                            break;
                        case 8:
                            this.$set(item, 'unReadNum', res.objectData.system_message)
                            break;
                        default:
                            break;
                    }
                })
            })
        },
        // 数据转换 时间戳转为时间格式
        formatTime(time) {
            return changeTime(time, 'time')
        },
        // 切换消息类型
        changeNoticeType(type) {
            this.noticeType = type
            this.currentPage = 1
            this.getData()
        },
        // 查看消息详情  赛事 和 新闻
        toDetail(item) {
            this.readSingleNotice(item)
            if(this.noticeType == 1) { // 赛事
                this.$router.push({
                    path: '/eventDetail',
                    query: {
                        eventId: item.mainId
                    }
                })
            } else if(this.noticeType == 3){ // 新闻
                this.$router.push({
                    path: '/newsDetail',
                    query: {
                        articleId: item.mainId
                    }
                })
            } else if(this.noticeType == 8) {
                this.getNoticeQuantity()
                this.getData()
            }
        },
        // 分页
        currentChange(page) {
            this.currentPage = page
            this.getData()
        },
        // 单条阅读消息
        readSingleNotice(item) {
            personalCenter.readSingleNotice({
                id: item.id,         
                accountId: this.accountId,
                type: item.type
            }).then(res => {
                item.isRead = true
                
            })
        },
        // 一键全读消息
        readAllNotice() {
            personalCenter.readAllNotice({
                type: this.noticeType,
                accountId: this.accountId
            }).then(res => {
                this.getNoticeQuantity()
                this.getData()
            })
        }
    },
    created() {
        let access_token = sessionStorage.getItem('access_token')
        if(access_token) {
            this.accountId = this.userInfo.id
            this.getNoticeQuantity()
            this.getData()
        }
        
        
        
    },
}
</script>
<style scoped>
    @import './style/myNotice.css';
</style>
